import { ApolloQueryResult } from '@apollo/client';

import { graphqlClient } from '@topconagriculture/graphql-client';

import * as UPDATE_SHARE from './gql/update.share.gql';
import { API_CLIENTS } from '../../../config/constants';
import { UpdateShareInput, UpdateSharePayload } from './share.type';

export const updateShare = (input: UpdateShareInput): Promise<ApolloQueryResult<UpdateSharePayload>> => {
  return graphqlClient
    .getClient(API_CLIENTS.graphqlClient)
    .mutate<UpdateShareInput>({
      mutation: UPDATE_SHARE,
      variables: {
        input,
      },
    })
    .then((response: any) => {
      return response.data.updateShare.share;
    });
};
